// skipcq: JS-W1028
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

function BeerProfileGlassIllustration({ glassPath }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'grey.50',
        borderRadius: 1,
        p: 3,
        minWidth: { sm: 200 },
        minHeight: 200,
      }}
    >
      <Box
        component="img"
        src={glassPath}
        alt=""
        sx={{ maxHeight: 180, maxWidth: '100%', objectFit: 'contain' }}
      />
    </Box>
  );
}

BeerProfileGlassIllustration.propTypes = {
  glassPath: PropTypes.string.isRequired,
};

export default BeerProfileGlassIllustration;
